module.exports = __webpack_public_path__ + "static/media/avatar_student.99bd99c3.png";